module.exports = __webpack_public_path__ + "static/AboutUs-ba90eacc5b74353c575009cb2121d537.jpg";